// 尾程商务/海外跟单列表页数据存储
const state = {
  // 列表页当前页数据（用于详情页左侧列表展示）
  currentPageJobs: [],
  // 当前选中的业务编号
  selectedJobNo: '',
  // 来源菜单类型：endCommerce/overseaTracking
  menuType: '',
  // 列表页是否需要刷新（详情页退回操作后设置）
  needRefreshList: false
}

const mutations = {
  // 设置列表页当前页数据
  SET_CURRENT_PAGE_JOBS: (state, data) => {
    state.currentPageJobs = data
  },
  // 设置当前选中的业务编号
  SET_SELECTED_JOB_NO: (state, jobNo) => {
    state.selectedJobNo = jobNo
  },
  // 设置来源菜单类型
  SET_MENU_TYPE: (state, type) => {
    state.menuType = type
  },
  // 清空数据
  CLEAR_DESTINATION_BUSINESS_DATA: (state) => {
    state.currentPageJobs = []
    state.selectedJobNo = ''
    state.menuType = ''
  },
  // 设置列表刷新标志
  SET_NEED_REFRESH_LIST: (state, val) => {
    state.needRefreshList = val
  }
}

const actions = {
  setCurrentPageJobs({ commit }, data) {
    commit('SET_CURRENT_PAGE_JOBS', data)
  },
  setSelectedJobNo({ commit }, jobNo) {
    commit('SET_SELECTED_JOB_NO', jobNo)
  },
  setMenuType({ commit }, type) {
    commit('SET_MENU_TYPE', type)
  },
  clearDestinationBusinessData({ commit }) {
    commit('CLEAR_DESTINATION_BUSINESS_DATA')
  },
  setNeedRefreshList({ commit }, val) {
    commit('SET_NEED_REFRESH_LIST', val)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}